import { useDispatch, useSelector } from "react-redux"
import { selectOriginCountry,selectDeclaration } from "@EUForms/selectors";
import { useEffect } from "react";
import { updateShipmentFieldValue } from "../reducer/headerSlice";
import {useEvent} from "@hooks/useEvent"

export const useValidateDecByDispatchCntry=(countryList,isImportShipment)=>{
    const dispatch=useDispatch()
    const selectedCountry=useSelector(isImportShipment?selectOriginCountry:(state)=>state.actorReducer.consigneeList?.[0]?.country)
    const selectedDeclaration=useSelector(selectDeclaration)
    const {saveForm}=useEvent("headerTab")
    useEffect(()=>{
        if(selectedCountry && countryList.length>0){
          let declaration=countryList?.find(c=>c.value==selectedCountry)?.additionalInfo
          // if(declaration==='EU'){
          //   declaration = 'EX'
          // }
          if(declaration!=selectedDeclaration){
            dispatch(updateShipmentFieldValue({declaration}))
            saveForm({declaration})
          }
        }
    },[selectedCountry,countryList])

    return ""
}